import { render } from "./create_discussion.html?vue&type=template&id=2889c665&external"
import script from "./create_discussion.js?vue&type=script&lang=js&external"
export * from "./create_discussion.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__